import mapbox from 'mapbox-gl';

mapbox.accessToken = MAPBOX_TOKEN;                        
const key = Symbol();

export { mapbox, key };